/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import packageJson from '../../package.json'

const initialState = {
  draftsAuthorId: null,
  pages: {},
  lastProps: {},
  lastModuleId: null,
  draftsAppVersion: packageJson.version,
}

// Slice
// automatically generates action creators
// and action types that correspond to the reducers and state
// https://redux-toolkit.js.org/api/createSlice
const draftsSlice = createSlice({
  name: 'drafts',
  initialState,
  reducers: {
    setEditorUserId(state, action) {
      state.draftsAuthorId = action.payload
    },
    savePageLocalstorage(state, action) {
      const { pageId, content, lang } = action.payload
      state.pages[pageId] = {}
      state.pages[pageId].content = content
      state.pages[pageId].editedAt = new Date().toISOString()
      state.pages[pageId].lang = lang
    },
    saveLastPropsOnLocalstorage(state, action) {
      const { content } = action.payload
      state.lastProps = content
    },
    saveLastModuleId(state, action) {
      const { moduleId } = action.payload
      state.lastModuleId = moduleId
    },
    deletePageLocalstorage(state, action) {
      const pageId = action.payload
      delete state.pages[pageId]
    },
    deleteAll(state) {
      state.pages = initialState.pages
      state.draftsAuthorId = initialState.draftsAuthorId
      state.draftsAppVersion = initialState.draftsAppVersion
    }
  }
})

// actions
export const {
  setEditorUserId,
  savePageLocalstorage,
  saveLastPropsOnLocalstorage,
  saveLastModuleId,
  deletePageLocalstorage,
  deleteAll,
} = draftsSlice.actions


// thunks
export const saveDraft = (
  { pageId, content, lang }
) => (dispatch) => {
  dispatch(savePageLocalstorage({ pageId, content, lang }))
}

export const saveLastProps = (
  { content }
) => (dispatch) => {
  dispatch(saveLastPropsOnLocalstorage({ content }))
}

export const saveLastModuleID = (
  { moduleId }
) => (dispatch) => {
  dispatch(saveLastModuleId({ moduleId }))
}

export const deleteDraft = (pageId) => (dispatch) => {
  dispatch(deletePageLocalstorage(pageId))
}

export const deleteAllDrafts = () => (dispatch) => {
  dispatch(deleteAll())
}

export default draftsSlice.reducer
